import styled, { createGlobalStyle } from 'styled-components';
import { boxShadow1 } from 'utils/style/colors';

export const GlobalMarqueeStyle = createGlobalStyle`
  @keyframes marquee {
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }
`;

export const SurveyReportModalContainer = styled.div`
  height: calc(100% - 2rem);
  max-height: 100%;
  overflow: visible;
  z-index: 1675;
  display: block;
  opacity: 1;
  top: 10%;
  margin: 1rem;
  border-radius: 1rem;
  box-shadow: ${boxShadow1};
  background: var(--exact-white);
  transition: all 0.5s ease-in-out;

  ${({ showAnimation, isOpen }) =>
    showAnimation
      ? `
        transform: scale(${isOpen ? '1' : '0.70'});
        opacity: ${isOpen ? '1' : '0'};
      `
      : `
        opacity: 1;
        transform: scaleX(1);
      `}
`;
